import React from 'react';

import './CompetitionAthleteStatus.scss';

export const CompetitionAthleteStatus = ({ text, contentClass = '', showText = true }) => (
  <div className={`status status-competition-athlete status-${text?.toLowerCase().replace(/\s/g, '')} ${contentClass}`}>
    <span>{showText ? text : ''}</span>
  </div>
);
